import { render, staticRenderFns } from "./receipt-info-header.vue?vue&type=template&id=501403de&scoped=true"
import script from "./receipt-info-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./receipt-info-header.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./receipt-info-header.vue?vue&type=style&index=0&id=501403de&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501403de",
  null
  
)

export default component.exports